import React, { useState, useEffect, useContext } from 'react';
import { AudioContext } from '../context/AudioContext';
import { Link } from 'react-router-dom';
import { fetchRadioChannels, fetchBlogs, fetchMostLikedChannels, fetchMostFavoriteChannels, fetchTopChannels } from '../services/HomePageService';
import {fetchCollections} from '../services/CollectionService';
import { BusinessSettingsContext } from "../context/BusinessSettingsContext";

const Home = () => {
    const { setCurrentChannel } = useContext(AudioContext);
    const [radioChannels, setRadioChannels] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [collections, setCollections] = useState([]);
    const [mostLikedChannels, setMostLikedChannels] = useState([]);
    const [mostFavoriteChannels, setMostFavoriteChannels] = useState([]);
    const [topChannels, setTopChannels] = useState([]);
    const [history, setHistory] = useState([]);
    const { settings } = useContext(BusinessSettingsContext);

    useEffect(() => {
            document.title = settings.website_name || "Website Name";
            const updateOrCreateMetaTag = (name, content) => {
                let metaTag = document.querySelector(`meta[name='${name}']`);
                if (metaTag) {
                    metaTag.setAttribute("content", content);
                } else {
                    const newMetaTag = document.createElement("meta");
                    newMetaTag.name = name;
                    newMetaTag.content = content;
                    document.head.appendChild(newMetaTag);
                }
            };

            updateOrCreateMetaTag("description", settings.description || "Listen to Radio Online live streaming. Enjoy the best music and shows.");
            updateOrCreateMetaTag("keywords", settings.keywords || "Radio Online, online radio, streaming, live music");

            const updateOrCreateOGTag = (property, content) => {
                let ogTag = document.querySelector(`meta[property='${property}']`);
                if (ogTag) {
                    ogTag.setAttribute("content", content);
                } else {
                    const newOGTag = document.createElement("meta");
                    newOGTag.setAttribute("property", property);
                    newOGTag.content = content;
                    document.head.appendChild(newOGTag);
                }
            };

            updateOrCreateOGTag("og:title", settings.website_name || "Website Name");
            updateOrCreateOGTag("og:description", settings.description || "Listen to Radio Online live streaming. Enjoy the best music and shows.");
            updateOrCreateOGTag("og:image", settings.website_logo || "https://yourwebsite.com/default-image.jpg");
            updateOrCreateOGTag("og:url", window.location.href);
            updateOrCreateOGTag("og:type", "website");

            updateOrCreateMetaTag("twitter:card", settings.website_logo);
            updateOrCreateMetaTag("twitter:title", settings.website_name || "Website Name");
            updateOrCreateMetaTag("twitter:description", settings.description || "Listen to Radio Online live streaming. Enjoy the best music and shows.");
            updateOrCreateMetaTag("twitter:image", settings.website_logo || "https://yourwebsite.com/default-image.jpg");
        }
    );

    // Fetch radio channels data from the Laravel API
    useEffect(() => {

        const loadChannels = async () => {
            try {
                const data = await fetchRadioChannels(); // Use the API function
                setRadioChannels(data);
            } catch (error) {
                console.error('Error loading Radio channels:', error);
            }
        };

        const loadCollections = async () => {
            try {
                const data = await fetchCollections(); // Use the API function
                setCollections(data);
            } catch (error) {
                console.error('Error loading Collections:', error);
            }
        };

        const loadBlogs = async () => {
            try {
                const data = await fetchBlogs(); // Use the API function
                setBlogs(data);
            } catch (error) {
                console.error('Error loading Blogs:', error);
            }
        };

        const loadMostLikedChannels = async () => {
            try {
                const data = await fetchMostLikedChannels(); // Use the API function
                setMostLikedChannels(data);
            } catch (error) {
                console.error('Error loading Most Liked Channels:', error);
            }
    
        };

        const loadMostFavoriteChannels = async () => {
            try {
                const data = await fetchMostFavoriteChannels(); // Use the API function
                setMostFavoriteChannels(data);
            } catch (error) {
                console.error('Error loading Most Favorite Channels:', error);
            }
    
        };

        const loadTopChannels = async () => {
            try {
                const data = await fetchTopChannels(); // Use the API function
                setTopChannels(data);
            } catch (error) {
                console.error('Error loading Top Channels:', error);
            }
    
        }

        loadChannels();
        loadCollections();
        loadBlogs();
        loadMostLikedChannels();
        loadMostFavoriteChannels();
        loadTopChannels();

        // Load history from sessionStorage
        const storedHistory = sessionStorage.getItem('radioHistory');
        if (storedHistory) {
            setHistory(JSON.parse(storedHistory));
        }
    }, []);

    const playChannel = (channel) => {
        setCurrentChannel(channel);

        // Update history
        let updatedHistory = [channel, ...history.filter(item => item.id !== channel.id)];
        if (updatedHistory.length > 12) updatedHistory.pop(); // Limit history to 5 items

        setHistory(updatedHistory);
        sessionStorage.setItem('radioHistory', JSON.stringify(updatedHistory));
    };

    return (
        <main class="main">
            <div class="container-fluid">

                {history.length > 0 && (
                    <section className="row row--grid">
                        <div className="col-12">
                            <div className="main__title">
                                <h2>Recently Played</h2>

                                <Link to="/history" class="main__link">See all <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></Link>
                            </div>
                        </div>
                        {history.map((channel) => (
                            <div className="col-3 col-sm-4 col-lg-1">
                                <div className="album">
                                    <div className="album__cover">
                                        <img src={channel.favicon} alt={`${channel.name} logo`} />
                                        <Link to="" onClick={() => playChannel(channel)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Z" />
                                            </svg>
                                        </Link>
                                    </div>
                                    <div className="album__title text-capitalize">
                                        <span class="text-sm"><Link to={`/channel/${channel.id}`}>{channel.name}</Link></span>
                                        <span><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </section>
                )}
               
                {/* <!-- releases --> */}
                <section class="row row--grid">
                    {/* <!-- title --> */}
                    <div class="col-12">
                        <div class="main__title">
                            <h2>New Channels</h2>

                            <Link to="/all-channels" class="main__link">See all <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></Link>
                        </div>
                    </div>
                    {/* <!-- end title --> */}

                    {radioChannels.map((channel) => (
                        <div class="col-4 col-sm-3 col-lg-2">
                            <div class="album">
                                <div class="album__cover">
                                    <img src={channel.favicon} alt={`${channel.name} logo`}/>
                                    <Link key={channel.id} onClick={() => playChannel(channel)}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z"/></svg></Link>
                                   
                                </div>
                                <div class="album__title text-capitalize">
                                    <h3><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h3>
                                    <span><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                </div>
                            </div>
                        </div>
                    ))}
                </section>

                <section class="row">
                    <div class="col-12">
                        <div class="main__title">
                            <h2>Collections</h2>

                            <Link to="/collections" class="main__link">See all <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></Link>
                        </div>
                    </div>

                    {collections.slice(0, 4).map((collection) => (
                        <div className="col-12 col-sm-6 col-lg-3" key={collection.id}>
                            <div className="post">
                                <Link to={`/collection/${collection.slug}`} className="post__img">
                                    <img
                                        src={collection.image}
                                        alt=""
                                        className="img-fluid"
                                        style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                    />
                                </Link>
                                <div className="post__content">
                                    <Link to={`/collection/${collection.slug}`} className="text-white text-decoration-none">
                                        {collection.name}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}


                </section>

                <section class="row row--grid">
                    <div class="col-12 col-md-6 col-xl-4">
                        <div class="row row--grid">
                            {/* <!-- title --> */}
                            <div class="col-12">
                                <div class="main__title">
                                    <h2>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.65,2.24a1,1,0,0,0-.8-.23l-13,2A1,1,0,0,0,7,5V15.35A3.45,3.45,0,0,0,5.5,15,3.5,3.5,0,1,0,9,18.5V10.86L20,9.17v4.18A3.45,3.45,0,0,0,18.5,13,3.5,3.5,0,1,0,22,16.5V3A1,1,0,0,0,21.65,2.24ZM5.5,20A1.5,1.5,0,1,1,7,18.5,1.5,1.5,0,0,1,5.5,20Zm13-2A1.5,1.5,0,1,1,20,16.5,1.5,1.5,0,0,1,18.5,18ZM20,7.14,9,8.83v-3L20,4.17Z"/></svg>
                                        <Link to="/top-channels">Top channels</Link>
                                    </h2>
                                </div>
                            </div>
                            {/* <!-- end title --> */}

                            <div class="col-12">
                                <ul class="main__list">
                                    {topChannels.map((channel) => (
                                        <li class="single-item">
                                            <span role='button' data-link data-title="Cinematic" data-artist="AudioPizza" data-img={channel.favicon} key={channel.id} onClick={() => playChannel(channel)} class="single-item__cover">
                                                <img src={channel.favicon} alt=""/>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z"/></svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z"/></svg>
                                            </span>
                                            <div class="single-item__title text-capitalize">
                                                <h4><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h4>
                                                <span><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                            </div>
                                            <span class="single-item__time">{channel.genre}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-xl-4">
                        <div class="row row--grid">
                            <div class="col-12">
                                <div class="main__title">
                                    <h2>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19.12,2.21A1,1,0,0,0,18.26,2l-8,2A1,1,0,0,0,9.5,5V15.35A3.45,3.45,0,0,0,8,15a3.5,3.5,0,1,0,3.5,3.5V10.78L18.74,9l.07,0L19,8.85l.15-.1a.93.93,0,0,0,.13-.15.78.78,0,0,0,.1-.15.55.55,0,0,0,.06-.18.58.58,0,0,0,0-.19.24.24,0,0,0,0-.08V3A1,1,0,0,0,19.12,2.21ZM8,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,8,20ZM17.5,7.22l-6,1.5V5.78l6-1.5Z"/></svg>
                                        <Link to="/most-liked-channels">Most Liked</Link>
                                    </h2>
                                </div>
                            </div>

                            <div class="col-12">
                                <ul class="main__list">
                                    {mostLikedChannels.map((channel) => (
                                        <li class="single-item">
                                            <span role='button' data-link data-title="Cinematic" data-artist="AudioPizza" data-img={channel.favicon} key={channel.id} onClick={() => playChannel(channel)} class="single-item__cover">
                                                <img src={channel.favicon} alt=""/>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z"/></svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z"/></svg>
                                            </span>
                                            <div class="single-item__title text-capitalize">
                                            <h4><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h4>
                                            <span><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                            </div>
                                            <span class="single-item__time">{channel.genre}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-xl-4">
                        <div class="row row--grid">
                            <div class="col-12">
                                <div class="main__title">
                                    <h2>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,15a4,4,0,0,0,4-4V5A4,4,0,0,0,8,5v6A4,4,0,0,0,12,15ZM10,5a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0Zm10,6a1,1,0,0,0-2,0A6,6,0,0,1,6,11a1,1,0,0,0-2,0,8,8,0,0,0,7,7.93V21H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13V18.93A8,8,0,0,0,20,11Z"/></svg>
                                        <Link to="/most-favorite-channels">Most Favorite</Link>
                                    </h2>
                                </div>
                            </div>

                            <div class="col-12">
                                <ul class="main__list">
                                    {mostFavoriteChannels.map((channel) => (
                                        <li class="single-item">
                                            <span role='button' data-link data-title="Cinematic" data-artist="AudioPizza" data-img={channel.favicon} key={channel.id} onClick={() => playChannel(channel)} class="single-item__cover">
                                                <img src={channel.favicon} alt=""/>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z"/></svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z"/></svg>
                                            </span>
                                            <div class="single-item__title text-capitalize">
                                            <h4><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h4>
                                            <span><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                            </div>
                                            <span class="single-item__time">{channel.genre}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="row">
                    <div class="col-12">
                        <div class="main__title">
                            <h2>Blogs</h2>

                            <Link to="/blogs" class="main__link">See all <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></Link>
                        </div>
                    </div>

                    {blogs.map((blog) => (
                        <div class="col-12 col-sm-6 col-lg-4">
                            <div class="post">
                                <Link to={`/blog/${blog.slug}`} class="post__img">
                                    <img src={blog.image} alt=""/>
                                </Link>

                                <div class="post__content">
                                    <Link to="#" class="post__category">{blog.category.name}</Link>
                                    <h3 class="post__title"><Link to={`/blog/${blog.slug}`}>{blog.title}</Link></h3>
                                    <div class="post__meta">
                                        <span class="post__date"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20ZM14.09814,9.63379,13,10.26807V7a1,1,0,0,0-2,0v5a1.00025,1.00025,0,0,0,1.5.86621l2.59814-1.5a1.00016,1.00016,0,1,0-1-1.73242Z"/></svg> {blog.published_at}</span>
                                        <span class="post__comments"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17,9H7a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Zm-4,4H7a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2ZM12,2A10,10,0,0,0,2,12a9.89,9.89,0,0,0,2.26,6.33l-2,2a1,1,0,0,0-.21,1.09A1,1,0,0,0,3,22h9A10,10,0,0,0,12,2Zm0,18H5.41l.93-.93a1,1,0,0,0,0-1.41A8,8,0,1,1,12,20Z"></path></svg> 18</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                </section>

                <div class="row">
                    <div class="col-12">
                        <div class="partners owl-carousel">
                            
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Home;
